import "./styles.scss";

export const Header = ()=>{
    return(
        <header className="header">
            <h1 className="title">AWESOME WEATHER</h1>
        </header>
    )
}